/**
 * 领域热点路由
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("regionalHotSpotsRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.hotfocus.regionalhotspots.internationalhotspots", {
        url: "/internationalhotspots",
        views: {
            "main@front.plan.hotfocus.regionalhotspots": {
                templateUrl: "./planningCenter/hotFocus/regionalHotSpots/internationalHotSpots/internationalHotSpots_tpl.html",
                controller: "internationalHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.regionalhotspots.nationalhotspots", {
        url: "/nationalhotspots",
        views: {
            "main@front.plan.hotfocus.regionalhotspots": {
                templateUrl: "./planningCenter/hotFocus/regionalHotSpots/nationalHotSpots/nationalHotSpots_tpl.html",
                controller: "nationalHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.regionalhotspots.zhejianghotspots", {
        url: "/zhejianghotspots",
        views: {
            "main@front.plan.hotfocus.regionalhotspots": {
                templateUrl: "./planningCenter/hotFocus/regionalHotSpots/zhejiangHotSpots/zhejiangHotSpots_tpl.html",
                controller: "zhejiangHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.regionalhotspots.countyHotSpots", {
        url: "/countyHotSpots/:district",
        views: {
            "main@front.plan.hotfocus.regionalhotspots": {
                templateUrl: "./planningCenter/hotFocus/regionalHotSpots/countyHotSpots/countyHotSpots.html",
                controller: "countyHotSpotsCtrl"
            }
        }
    });
}]);